import { useAddJobAdPageToDomainMutation } from "@/redux/reducer/customers.api";
import { ModalForm, TalentechFormFieldTypes } from "@talentech/components";
import React from "react";
import { toast } from "react-toastify";

interface ModalProps {
  showModal: boolean;
  toggleModal: () => void;
  onAssigned?: () => void;
  options: any[];

  domain_id: string;
  tenant_id: string;
  joblist_page_id: string;
}

interface ModalFormValues {
  job_ad: {
    site_id: {
      value: string;
      label: string;
    };
  };
}

const AssignJobAd: React.FC<ModalProps> = ({
  options,
  tenant_id,
  domain_id,
  joblist_page_id,
  onAssigned,
  ...props
}) => {
  const [addJobAd] = useAddJobAdPageToDomainMutation();
  const handleSubmit = (data: ModalFormValues) => {
    const promise = addJobAd({
      job_ad_page_id: data.job_ad.site_id.value,
      joblist_page_id,
      domain_id,
      tenant_id,
    });

    const toastId = toast.loading("Assigning job ad...");
    promise
      .unwrap()
      .then(() => {
        toast.update(toastId, { render: "Job ad assigned", type: "success", isLoading: false, autoClose: null });
        props.toggleModal();
        onAssigned?.();
      })
      .catch((err) => {
        toast.update(toastId, {
          render: err?.status === 409
            ? "This job ad is already assigned to a job list page"
            : "Failed to assign job ad",
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });
      });
  };

  return (
    <ModalForm
      modal={{
        title: "Assign Job ad",
        ...props,
      }}
      form={{
        formFields: {
          fields: [
            {
              field: "site_id",
              label: "Job ads",
              type: TalentechFormFieldTypes.SELECT,
              size: {
                xs: 12,
              },
              options: {
                options,
              },
            },
          ],
          id: "job_ad",
          section: "",
        },
        handleSubmit,
      }}
    />
  );
};

export default AssignJobAd;
